import { render, staticRenderFns } from "./HolyCross.vue?vue&type=template&id=1e3e3796&"
import script from "./HolyCross.vue?vue&type=script&lang=js&"
export * from "./HolyCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports